/* import __COLOCATED_TEMPLATE__ from './single-option-inserter.hbs.js'; */
import Component from '@glimmer/component';
export default class SingleOptionInserter extends Component {
  get defaultInserterIsIfElseStatement() {
    return this.args.composer.config.inserters?.ifElseStatementInserter && this.args.options?.singleOptionInserterMode;
  }
  get isVisible() {
    if (this.args.composer.state) {
      return this.args.composer.state.hoverInfo?.editorHovered && this.args.composer.state.selectionIsEmpty && !this.args.composer.state.hasConditionalBlocks && !this.args.composer.state.isEditing;
    }
    return false;
  }
}